const defaultSystemFonts = [
  'Roboto',
  'notoserif',
  'sans-serif-light',
  'sans-serif-thin',
  'sans-serif-medium'
];

export default defaultSystemFonts;
